import React from "react";
import { useTranslation } from "react-i18next";
import { DisplayName } from "../DisplayName";
import CustomColumnDisplay from "@components/Common/CustomColumnDisplay";
import { CustomIcons } from "./CustomIcons";

export function ArrayOfCustomColumns(
    isArchivedLanguagesClicked: boolean,
    shopState: any,
    setShopState: Function,
    modalState: any,
    setModalState: Function
) {
    const { t } = useTranslation();

    return [
        {
            indexOFColumn: 2,
            columnName: t("Language"),
            customJsx: (e: any) => <NumberLangues e={e} />,
            filterName: t("Language"),
            canFilter: true,
        },
        {
            indexOFColumn: 3,
            columnName: t("Display name"),
            customJsx: (e: any) => <DisplayName e={e} />,
            filterName: t("Display name"),
            canFilter: true,
        },
        {
            indexOFColumn: 4,
            columnName: t("Adresse"),
            customJsx: (e: any) => (
                <CustomColumnDisplay text={e.selectedRow.Adresse} />
            ),
            filterName: "Adresse",
            canFilter: true,
        },
        {
            indexOFColumn: 6,
            columnName: t("Country"),
            customJsx: (e: any) => <GetCountry e={e} />,
            filterName: t("Country"),
            canFilter: true,
        },
        {
            indexOFColumn: 7,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    isArchivedLanguagesClicked={isArchivedLanguagesClicked}
                    shopState={shopState}
                    setShopState={setShopState}
                    modalState={modalState}
                    setModalState={setModalState}
                />
            ),
        },
    ];
}

function NumberLangues(e: any) {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            {e.e.selectedRow?.subRows !== undefined ? (
                <h6 className="badge__clz lan_icn_BTcounter">
                    {e.e.selectedRow[t("Shop")] !== ""
                        ? e.e.selectedRow.subRows?.length
                        : 0}
                </h6>
            ) : (
                e.e.selectedRow[t("Language")]
            )}
        </React.Fragment>
    );
}

function GetCountry(e: any) {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            {e.e.selectedRow?.subRows !== undefined
                ? e.e.selectedRow.pays
                : e.e.selectedRow[t("Country")]}
        </React.Fragment>
    );
}
